module.exports = __webpack_public_path__ + "fontawesome-webfont.a35720c2fed2c7f043bc.woff";


//////////////////
// WEBPACK FOOTER
// C:/WS/Fusion/FusionDashboard/resources/layout/fonts/fontawesome-webfont.woff?v=4.5.0
// module id = ../../../../../resources/layout/fonts/fontawesome-webfont.woff?v=4.5.0
// module chunks = styles